<template>
  <div class="form container">
    <div>
      <div class="text-center">
        <img
          class="mb-4 mx-auto"
          src="../assets/logowhite.svg"
          alt="logo"
          width="320"
        />
        <h1 class="fw mb-3">Sign in to COPLAN.</h1>
        <h5>We suggest using the email address that you use at work.</h5>
      </div>
      <OAuthButtons />
      <hr class="my-4" />

      <RegisterForm formType="login" @submit="handleLogin" />
      <small class="text-body-secondary"
        ><span class="text">New to COPLAN ? </span>
        <router-link to="/Register" class="link"
          >Create an account
        </router-link>
      </small>
    </div>
    <BasicAlert :visible="showAlert" message="Please Check Your Form!" />
  </div>
</template>

<script>
import OAuthButtons from "@/components/auth/OAuthButtons.vue";
import RegisterForm from "@/components/auth/authForm.vue";
import "@/assets/styles/authStyles.css";
import BasicAlert from "@/components/global/BasicAlert.vue"; // 导入 Alert 组件

export default {
  components: {
    OAuthButtons,
    RegisterForm,
    BasicAlert, // 正确的组件注册方式
  },
  data() {
    return {
      showAlert: false,
    };
  },
  methods: {
    async handleLogin(formData) {
      // 假设检查 formData 中的必需字段
      if (!formData.username || !formData.password) {
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
        return;
      }
      try {
        console.log("Logging in with:", formData);
        this.$router.push("/");
      } catch (error) {
        console.error("Login error:", error);
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      }
    },
  },
};
</script>

<style scoped></style>
